import React from "react";
import { BaseURL } from "../../APIs/APIUrls";

export default function AttachMents({ PropertyObject }) {
  const attachments = React.useMemo(() => {
    const source = Array.isArray(PropertyObject)
      ? PropertyObject
      : Array.isArray(PropertyObject?._lstPropertyDocument)
        ? PropertyObject._lstPropertyDocument
        : [];

    return source
      .filter((item) => item?.IsActive !== false)
      .sort((a, b) => (a?.DocumentId ?? 0) - (b?.DocumentId ?? 0));
  }, [PropertyObject]);

  const getFileUrl = (path) => {
    if (!path) return "#";
    if (/^https?:\/\//i.test(path)) return path;
    return `${BaseURL}${String(path).replace(/^\/+/, "")}`;
  };


  return (
    <>


      {attachments.length === 0 ? null : (<>
        <h6 className="title fw-6">File Attachments</h6>
        <div className="row">
          {attachments.map((item, index) => (
            <div className="col-sm-6" key={item.DocumentId ?? index}>
              <a
                href={getFileUrl(item.FilePath)}
                target="_blank"
                rel="noreferrer"
                className="attachments-item"
              >
                {/* <div className="box-icon w-60">
                  <span className="icon icon-doc"></span>
                </div> */}
                <span>{item.FileName || `Document ${index + 1}`}</span>
                <i className="icon icon-download" />
              </a>
            </div>
          ))}
        </div>
        </>
      )}
    </>
  );
}
